



















import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'dashboard'
})
export default class Dashboard extends Vue
{
    clickSong = this.$store.state.global.clickSong;
    backgroundSong = this.$store.state.global.backgroundSong;

    mounted()
    {
        this.$store.commit('disableEffect');
    }

    handleClick()
    {
        this.clickSong.play();
    }

    playSong()
    {
        this.$store.commit('startSound');
    }
    logout()
    {
        this.redirect({ name: 'dashboard' });
        this.$auth.logout();
    }
}
